<template>
  <div class="social-wrap" :class="{ 'no-cursor': bindAccountNum === 1 && isBind }" @click="lgoin">
    <div class="logo-wrap">
      <span class="logo facebook"></span>
      <span class="name">Facebook</span>
    </div>
    <div class="account-name" :class="{ 'no-arr': bindAccountNum === 1 && isBind }">
      <template v-if="isBind">{{ isBind }}</template>
      <template v-else>{{ $t('web_unbind') }}</template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { bindAccount, unbindAccount } from '../utils/Qtbridge'
export default {
  name: 'AccountFacebook',
  data () {
    return {
      visible: false,
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      bindInfo: state => state.bindInfo.facebook,
    }),
    isBind () {
      return this.bindInfo.name || this.bindInfo.email || ''
    }
  },
  methods: {
    ...mapMutations({
      setBindInfoItem: 'setBindInfoItem'
    }),
    lgoin () {
      if (this.isBind) {
        if (this.bindAccountNum <= 1) return
        this.$dialog(
          {
            title: this.$t('web_tips_title'),
            text: this.$t('web_unbind_tips', { 0: 'Facebook' }),
            confirmTxt: this.$t('test_confirm'),
            cancelTxt: this.$t('test_cancel')
          },
          this.onFBLogin
        )
      } else {
        this.onFBLogin()
      }
    },
    onFBLogin () {
      const _this = this
      // 检测FB登录状态
      window.FB.logout()
      window.FB.login(function(loginRes) {
        console.log(arguments)
        _this.$Spin.show()
        if (loginRes.status === 'connected') {
          // Logged into your webpage and Facebook.
          const authResponse = loginRes.authResponse
          window.FB.api('/me', function(profileRes) {
            if (!profileRes.id) {
              _this.$msg.success(_this.$t('web_bind_fail'))
              window.FB.logout()
              this.$Spin.hide()
            }
            console.log('authResponse', authResponse, profileRes)
            _this.userInfo = {
              id: profileRes.id || '',
              name: profileRes.name,
              token: authResponse.accessToken,
              type: 'facebook',
              expire: authResponse.expiresIn
            }
            if (_this.isBind) {
              _this.unbind()
            } else {
              _this.login()
            }
          })
        } else {
          _this.$msg.success(_this.$t('web_bind_fail'))
          _this.$Spin.hide()
        }
      }, { scope: 'public_profile, email' })
    },
    login () {
      bindAccount(this.userInfo)
        .then(res => {
          if (res.code !== 0) this.$msg.success(res.msg || this.$t('web_bind_fail'))
          this.setBindInfoItem({
            key: 'facebook',
            value: {
              name: this.userInfo.name
            }
          })
          this.$msg.success(this.$t('web_bind_ok'))
          this.$Spin.hide()
        })
        .catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.$Spin.hide()
        })
    },
    unbind () {
      unbindAccount(this.userInfo)
        .then(res => {
          if (res.code !== 0) this.$msg.success(res.msg)
          this.setBindInfoItem({
            key: 'facebook',
            value: {
              name: '',
              email: ''
            }
          })
          window.unbindClose()
          this.$msg.success(this.$t('web_tips_unbind'))
          this.$Spin.hide()
        })
        .catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.$Spin.hide()
        })
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
